function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

function customMillify(n) {
  const millnames = ['', 'k', 'M', 'B', 'T', 'Q'];

  if (n === 0) return '0';

  // Ensure n is treated as a number
  n = Math.abs(Number(n));

  // Determine the magnitude index
  const millidx = Math.max(
    0,
    Math.min(millnames.length - 1, Math.floor(Math.log10(n) / 3)),
  );
  const scaled = n / Math.pow(10, 3 * millidx);

  // Format the number as an integer
  const formatted = scaled.toFixed(0);

  return `${formatted}${millnames[millidx]}`;
}

async function triggerPostRequest(faq_id, event) {
  try {
    const response = await fetch(`${window.location.origin}/faqs/event`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        faq_id: faq_id,
        event: event,
        current_url: window.location.href,
      }),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

async function handleEvent(faqId, event) {
  const llt = getCookie('llt');
  if (!llt) {
    const current_url = window.location.href;
    window.location.href = `${window.location.origin}/faqs/event?current_url=${current_url}&event=${event}`;
  } else {
    return await triggerPostRequest(faqId, event);
  }
}

function updateLikeDislikeCount(likeCount, dislikeCount) {
  document.getElementById('likeCount').textContent = customMillify(likeCount);
  document.getElementById('dislikeCount').textContent =
    customMillify(dislikeCount);
}

function updateDisplay(action, showBeforeButton, hideAfterButton) {
  document.getElementById(`${action}ButtonBefore`).style.display =
    showBeforeButton ? 'block' : 'none';
  document.getElementById(`${action}ButtonAfter`).style.display =
    hideAfterButton ? 'block' : 'none';
  document.getElementById('likeCount').style.display = 'block';
  document.getElementById('dislikeCount').style.display = 'block';
}

document
  .getElementById('likeButtonBefore')
  .addEventListener('click', async () => {
    const faqId = document
      .getElementById('likeButtonBefore')
      .getAttribute('data-faqId');
    const response = await handleEvent(faqId, 'like');

    if (response.success === true) {
      if (response.action === 'create') {
        updateDisplay('like', false, true);
        updateDisplay('dislike', true, false);
      } else {
        updateDisplay('like', true, false);
        updateDisplay('dislike', true, false);
      }
      updateLikeDislikeCount(response.like_count, response.dislike_count);
    }
  });

document
  .getElementById('likeButtonAfter')
  .addEventListener('click', async () => {
    const faqId = document
      .getElementById('likeButtonAfter')
      .getAttribute('data-faqId');
    const response = await handleEvent(faqId, 'like');

    if (response.success === true) {
      if (response.action === 'create') {
        updateDisplay('like', false, true);
        updateDisplay('dislike', true, false);
      } else {
        updateDisplay('like', true, false);
        updateDisplay('dislike', true, false);
      }
      updateLikeDislikeCount(response.like_count, response.dislike_count);
    }
  });

document
  .getElementById('dislikeButtonBefore')
  .addEventListener('click', async () => {
    const faqId = document
      .getElementById('dislikeButtonBefore')
      .getAttribute('data-faqId');
    const response = await handleEvent(faqId, 'dislike');

    if (response.success === true) {
      if (response.action === 'create') {
        updateDisplay('dislike', false, true);
        updateDisplay('like', true, false);
      } else {
        updateDisplay('dislike', true, false);
        updateDisplay('like', true, false);
      }
      updateLikeDislikeCount(response.like_count, response.dislike_count);
    }
  });

document
  .getElementById('dislikeButtonAfter')
  .addEventListener('click', async () => {
    const faqId = document
      .getElementById('dislikeButtonAfter')
      .getAttribute('data-faqId');
    const response = await handleEvent(faqId, 'dislike');

    if (response.success === true) {
      if (response.action === 'create') {
        updateDisplay('like', true, false);
        updateDisplay('dislike', false, true);
      } else {
        updateDisplay('like', true, false);
        updateDisplay('dislike', true, false);
      }
      updateLikeDislikeCount(response.like_count, response.dislike_count);
    }
  });

document.addEventListener('DOMContentLoaded', async () => {
  const queryParams = new URLSearchParams(window.location.search);
  const isLoggedIn = queryParams.get('loggedIn');
  const faq_event = queryParams.get('faq_event');

  if (isLoggedIn && faq_event) {
    const faqId = document
      .getElementById(`${faq_event}ButtonBefore`)
      .getAttribute('data-faqId');
    const response = await handleEvent(faqId, faq_event);

    if (response.success === true) {
      if (faq_event === 'like') {
        if (response.action === 'create') {
          updateDisplay('like', false, true);
          updateDisplay('dislike', true, false);
        } else {
          updateDisplay('like', true, false);
        }
        updateLikeDislikeCount(response.like_count, response.dislike_count);
      } else if (faq_event === 'dislike') {
        if (response.action === 'create') {
          updateDisplay('dislike', false, true);
          updateDisplay('like', true, false);
        } else {
          updateDisplay('dislike', true, false);
        }
        updateLikeDislikeCount(response.like_count, response.dislike_count);
      }
    }
  }
});

document.getElementById('scrollUpButton').addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
});
